<template lang="html">
  <root class="admin-business-add">

    <admin-nav></admin-nav>
    <page-header name="Add business" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (EN)</label>
                <input type="text" v-model="business.name.en">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (AR)</label>
                <input type="text" v-model="business.name.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Description (EN)</label>
                <textarea class="materialize-textarea" v-model="business.description.en"></textarea>
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Description (AR)</label>
                <textarea class="materialize-textarea" v-model="business.description.ar"></textarea>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-select">
                <select v-model="business.country" @change="collecCities">
                  <option :value="country.key" v-for="country in countries">{{ country.name.en }}</option>
                </select>
                <label>Country</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-select">
                <select @change="chooseCity" v-model="city">
                  <option v-for="city in cities" :value="city.key" :disabled="__isChoosen(city.key)">{{ city.name.en }}</option>
                </select>
                <label>Cities</label>
              </div>

              <div class="chip" v-for="city in business.cities" @click="unchooseCity(city)">
                {{ __cityName(city) }} <i class="material-icons">close</i>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Delivery time (EN)</label>
                <input type="text" v-model="business.delivery_time.en">
              </div>
            </div>
            <div class="col m6">
              <div class="mui-textfield">
                <label>Delivery time (AR)</label>
                <input type="text" v-model="business.delivery_time.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Display photo</span>
                  <input type="file" accept="image/jpeg" :disabled="isSending" @change="uploadPhoto('display', $event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Cover photo</span>
                  <input type="file" accept="image/jpeg" :disabled="isSending" @change="uploadPhoto('cover', $event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="mui-textfield">
                <label>Deeplink hash</label>
                <input type="text" v-model="business.deeplink_hash">
              </div>
            </div>
          </div>
        </div>

        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Name (EN)</th>
                <td>{{business.name.en}}</td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td>{{business.name.ar}}</td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td>{{business.description.en}}</td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td>{{business.description.ar}}</td>
              </tr>
              <tr>
                <th>Country</th>
                <td>{{business.country}}</td>
              </tr>
              <tr>
                <th>Cities</th>
                <td>
                    <span v-for="city in business.cities">{{ __cityName(city) }}, </span>
                </td>
              </tr>
              <tr>
                <th>Delivery time (EN)</th>
                <td>{{business.delivery_time.en}}</td>
              </tr>
              <tr>
                <th>Delivery time (AR)</th>
                <td>{{business.delivery_time.ar}}</td>
              </tr>
              <tr>
                <th>Display photo</th>
                <td><img :src="displayPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td><img :src="coverPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Deeplink hash</th>
                <td>{{ business.deeplink_hash }}</td>
              </tr>
              <tr>
                <th>Verified</th>
                <td>{{ business.is_verified ? 'Yes': 'No' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row">
        <div class="col m2 offset-m5">
          <div class="switch">
            <label>
              Verified
              <input type="checkbox" v-model="business.is_verified">
              <span class="lever"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disabled="isSending" @click="add">Add</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";
import _ from "lodash";
import config from "../../../app.config.json";
import * as axios from "axios";

export default {
  data() {
    return {
      business: {
        name: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
        delivery_time: {
          en: "",
          ar: "",
        },
        country: "",
        cities: [],
        is_open: false,
        is_verified: false,
        is_accept_agreement: false,
        is_archived: false,
        deeplink_hash: "",
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        user_key: null,
        name_lower_case: null,
        is_cover_photo_updated: true,
        is_display_photo_updated: true,
      },
      isSending: false,
      countries: [],
      cities: [],
      city: "",
      photos: [],
      displayPhotoPreview: "",
      coverPhotoPreview: "",
    };
  },

  methods: {
    // Add dish
    add() {
      // All fields are required
      if (
        !this.business.name.en ||
        !this.business.name.ar ||
        !this.business.description.en ||
        !this.business.description.ar ||
        !this.business.country ||
        !this.business.cities.length ||
        !this.business.delivery_time.en ||
        !this.business.delivery_time.ar ||
        !this.business.timestamp ||
        this.photos.length < 2
      )
        return Materialize.toast("All fields are required", 4000);

      // Prevent invalid userkey
      if (!this.$route.params.userKey) {
        return Materialize.toast("User is not valid", 4000);
      }

      this.isSending = true;

      this.business.user_key = this.$route.params.userKey;
      this.business.name_lower_case = this.business.name.en
        .replace(/\s/g, "")
        .trim()
        .toLowerCase();

      // Push
      firebase
        .database()
        .ref("businesses")
        .push(this.business)
        .then((businessSnap) => {
          let loop = 2;

          firebase
            .database()
            .ref("users/" + this.$route.params.userKey)
            .update({ due_payments: 0 });

          // Upload photos
          for (let photo of this.photos) {
            firebase
              .storage()
              .ref("business/" + photo.type + "/" + businessSnap.key + ".jpeg")
              .put(photo.file)
              .then((photoSnap) => {
                loop--;

                // End loop
                if (!loop) {
                  Materialize.toast("Added", 4000);
                  this.$router.push({ name: "Businesses" });
                }
              });
          }

          this.sendWelcomePushNotification(this.$route.params.userKey);
        });
    },

    sendWelcomePushNotification(userKey) {
      console.log("Send Welcome Push Notification: " + userKey);

      firebase
        .database()
        .ref("users/" + userKey)
        .once("value")
        .then((userSnap) => {
          let userData = userSnap.val();
          let businessName = this.business.name[userData.lang];
          let contents = {
            en: "Congratulations! " + businessName + " is in Awani now.",
            ar: "مبروووك! " + businessName + " في أواني الآن",
          };
          var data = {
            app_id: config.onesignal_api[config.app.env]["app_id"],
            filters: [
              {
                field: "tag",
                key: "auth_user_key",
                relation: "=",
                value: userKey,
              },
            ],
            contents: { en: contents[userData.lang] },
            data: {
              type: "accept_business_contract",
            },
            priority: 10,
          };

          const push = axios.create({
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              Authorization:
                "Basic " + config.onesignal_api[config.app.env]["rest_key"],
            },
          });

          console.log("Data: " + JSON.stringify(data));

          push
            .post("https://onesignal.com/api/v1/notifications", data)
            .catch((ex) => {
              console.log(ex);
              console.log(JSON.stringify(ex));
            });
        });
    },

    // Collect cities
    collecCities() {
      // Reset cities
      this.cities = [];
      this.business.cities = [];

      // Collect
      firebase
        .database()
        .ref("countries/" + this.business.country + "/cities")
        .once("value")
        .then((citiesSnap) => {
          citiesSnap.forEach((citySnap) => {
            // Data
            let cityData = citySnap.val();
            cityData["key"] = citySnap.key;

            // Push
            this.cities.push(cityData);
          });
        });
    },

    // Choose city
    chooseCity() {
      this.business.cities.push(this.city);
    },

    // Unchoose city
    unchooseCity(key) {
      let index = this.business.cities.indexOf(key);
      this.business.cities.splice(index, 1);
    },

    // City name from key
    __cityName(key) {
      let city = _.find(this.cities, { key });
      return city.name.en;
    },

    // Check choosen city
    __isChoosen(key) {
      let choosenCities = this.business.cities;
      return choosenCities.includes(key) ? true : false;
    },

    // Upload display photo
    uploadPhoto(type, event) {
      // Collect photo
      let photo = event.target.files || event.dataTransfer.files;

      // Validate
      if (!photo.length) {
        Materialize.toast("Unable to upload " + type + " photo", 4000);
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        if (type == "display") {
          return (this.displayPhotoPreview = e.target.result);
        }
        this.coverPhotoPreview = e.target.result;
      };
      reader.readAsDataURL(photo[0]);

      this.photos.push({ type, file: photo[0] });
    },

    collectCountries() {
      firebase
        .database()
        .ref("countries")
        .once("value")
        .then((countriesSnap) => {
          countriesSnap.forEach((countrySnap) => {
            let country = countrySnap.val();
            country["key"] = countrySnap.key;
            this.countries.push(country);
          });
        });
    },
  },

  mounted() {
    this.collectCountries();
  },
};
</script>

<style lang="scss">
.admin-business-add {
  .switch {
    display: flex;
    justify-content: center;
  }

  .photo {
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/BusinessAdd.vue